import { ShortCode } from '@highereducation/wordpress';
import { Separator } from '@highereducation/hen-ui';

interface SeparatorShortcodeProps {
  orientation?: 'horizontal' | 'vertical';
  decorative?: 'true' | 'false';
  [key: string]: unknown;
}

/**
 * SeparatorShortcode - Shortcode wrapper for Separator atomic component
 *
 * Renders a 1px divider line between content sections.
 * Use between major sections for visual separation.
 *
 * Supported shortcode attributes:
 * - orientation: 'horizontal' | 'vertical' (default: 'horizontal')
 * - decorative: 'true' | 'false' (default: 'true')
 *
 * @example WordPress shortcode usage:
 * [hen-ui-separator]
 * [hen-ui-separator orientation="horizontal"]
 */
export const SeparatorShortcode: ShortCode<SeparatorShortcodeProps> = {
  component: ({ orientation = 'horizontal', decorative = 'true' }) => {
    return (
      <Separator orientation={orientation} decorative={decorative === 'true'} />
    );
  },
};
